/* Willow product-card interactions.
   Loaded once with defer instead of embedding the same handlers in every rendered card. */
/* Willow — hover (desktop) / tap (mobile) a finish thumbnail -> crossfade the card photo.
         Delegated + guarded so it binds once and also handles cards appended by Show more. */
      (function(){
        if(window.__wvCardSwatch){ return; } window.__wvCardSwatch = true;
        var touch = matchMedia('(hover: none), (pointer: coarse), (max-width: 767px)').matches;
        var finePointer = matchMedia('(hover: hover) and (pointer: fine)');
        var finishTip;
        var finishTipAnchor;
        var finishTipName;
        var finishTipStatus;
        function getFinishTip(){
          if(finishTip){ return finishTip; }
          finishTip = document.createElement('div');
          finishTip.className = 'wv-card-finish-tooltip';
          finishTip.setAttribute('role','tooltip');
          finishTip.hidden = true;
          finishTipName = document.createElement('span');
          finishTipName.className = 'wv-card-finish-tooltip__name';
          finishTipStatus = document.createElement('span');
          finishTipStatus.className = 'wv-card-finish-tooltip__status';
          finishTipStatus.textContent = 'SOLD OUT';
          finishTip.append(finishTipName, finishTipStatus);
          document.body.appendChild(finishTip);
          return finishTip;
        }
        function showFinishTip(swatch){
          if(touch || !finePointer.matches || !swatch){ return; }
          var label = swatch.getAttribute('data-fin') || swatch.getAttribute('aria-label') || '';
          if(!label){ return; }
          var sold = swatch.getAttribute('data-available') !== 'true';
          label = label.replace(/\s*(?:·|—|-)\s*Sold out\s*$/i,'');
          var tip = getFinishTip();
          finishTipName.textContent = label;
          finishTipStatus.hidden = !sold;
          tip.classList.toggle('is-soldout',sold);
          tip.hidden = false;
          var anchorRect = swatch.getBoundingClientRect();
          var tipRect = tip.getBoundingClientRect();
          var left = anchorRect.left + (anchorRect.width - tipRect.width) / 2;
          left = Math.max(8, Math.min(left, window.innerWidth - tipRect.width - 8));
          var top = anchorRect.top - tipRect.height - 10;
          if(top < 8){ top = Math.min(window.innerHeight-tipRect.height-8,anchorRect.bottom+10); }
          tip.style.left = Math.round(left) + 'px';
          tip.style.top = Math.round(top) + 'px';
          finishTipAnchor = swatch;
        }
        function hideFinishTip(){
          if(finishTip){ finishTip.hidden = true; }
          finishTipAnchor = null;
        }
        document.addEventListener('pointerover', function(e){
          var s=e.target.closest && e.target.closest('.product-card .wv-card-fin[data-fin]');
          if(s && s!==finishTipAnchor){ showFinishTip(s); }
        });
        document.addEventListener('pointerout', function(e){
          var s=e.target.closest && e.target.closest('.product-card .wv-card-fin[data-fin]');
          if(s && s===finishTipAnchor && !s.contains(e.relatedTarget)){ hideFinishTip(); }
        });
        document.addEventListener('focusin', function(e){
          var s=e.target.closest && e.target.closest('.product-card .wv-card-fin[data-fin]');
          if(s){ showFinishTip(s); }
        });
        document.addEventListener('focusout', function(e){
          if(finishTipAnchor && !finishTipAnchor.contains(e.relatedTarget)){ hideFinishTip(); }
        });
        document.addEventListener('scroll', function(){ if(finishTipAnchor){ hideFinishTip(); } }, {capture:true,passive:true});
        window.addEventListener('resize', function(){ if(finishTipAnchor){ hideFinishTip(); } }, {passive:true});
        document.addEventListener('click', function(e){
          var more = e.target.closest && e.target.closest('.wv-card-finmore');
          if(!more){ return; }
          e.preventDefault(); e.stopPropagation();
          var fins = more.closest('.wv-card-fins');
          if(!fins){ return; }
          fins.classList.add('is-expanded');
          var rail = fins.closest('.wv-card-finrail');
          if(rail){ rail.classList.add('is-expanded'); }
          more.setAttribute('aria-expanded', 'true');
        }, true);
        function imgEl(card){ var m = card && card.querySelector('.product-card__media'); return m ? (m.querySelector('a img') || m.querySelector('img')) : null; }
        function imageOp(el){ el.__wvImageOp = (el.__wvImageOp || 0) + 1; return el.__wvImageOp; }
        var reduceCardMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
        function commitImage(el, op, url, srcset, alt){
          if(op!==el.__wvImageOp){ return; }
          if(el.__wvImageAnimation){ el.__wvImageAnimation.cancel(); el.__wvImageAnimation=null; }
          el.style.removeProperty('transition');
          el.style.opacity='1';
          if(srcset){ el.setAttribute('srcset',srcset); }
          else{ el.removeAttribute('srcset'); }
          if(typeof alt==='string'){ el.alt=alt; }
          el.src=url;
          if((!reduceCardMotion || !reduceCardMotion.matches) && typeof el.animate==='function'){
            el.__wvImageAnimation=el.animate(
              [{opacity:.86},{opacity:1}],
              {duration:180,easing:'cubic-bezier(.22,1,.36,1)'}
            );
            el.__wvImageAnimation.finished.catch(function(){}).then(function(){
              if(op===el.__wvImageOp){ el.__wvImageAnimation=null; el.style.opacity='1'; }
            });
          }
        }
        function loadAndCommit(el, op, url, srcset, alt){
          var pre=new Image();
          pre.decoding='async';
          pre.onload=function(){ commitImage(el,op,url,srcset,alt); };
          pre.src=url;
        }
        function fade(el, url, alt){
          if(!el || !url){ return; }
          var cur=el.currentSrc || el.src;
          if(!el.dataset.wvO){
            el.dataset.wvO=cur;
            el.dataset.wvS=el.getAttribute('srcset') || '';
            el.dataset.wvA=el.getAttribute('alt') || '';
          }
          if(cur===url){
            imageOp(el);
            if(typeof alt==='string'){ el.alt=alt; }
            return;
          }
          var op=imageOp(el);
          loadAndCommit(el,op,url,'',alt);
        }
        function restore(card){
          var el=imgEl(card);
          if(!el || !el.dataset.wvO){ return; }
          var op=imageOp(el);
          loadAndCommit(el,op,el.dataset.wvO,el.dataset.wvS || '',el.dataset.wvA || '');
        }
        function retarget(card, swatch){
          if(!card || !swatch){ return; }
          var href = swatch.href || swatch.getAttribute('href');
          var variantId = swatch.getAttribute('data-variant-id');
          if(!href){ return; }
          var links = card.querySelectorAll('.product-card__media > a[href], .product-card__title, .quick-add a[href], a.button[is="hover-link"]');
          for(var i=0;i<links.length;i++){ links[i].setAttribute('href', href); }
          var quickView = card.querySelector('quick-view[data-product-url]');
          if(quickView){ quickView.setAttribute('data-product-url', href); }
          if(variantId){
            var inputs = card.querySelectorAll('[data-wv-card-variant-input]');
            for(var j=0;j<inputs.length;j++){ inputs[j].value = variantId; }
            var submits = card.querySelectorAll('[data-wv-card-variant-submit]');
            for(var k=0;k<submits.length;k++){ submits[k].setAttribute('data-variant-id', variantId); }
          }
        }
        function syncFinishLabel(card, swatch){
          if(!card || !swatch){ return; }
          var labelEl = card.querySelector('[data-wv-card-finish-label]');
          if(!labelEl){ return; }
          var finish = swatch.getAttribute('data-fin') || swatch.getAttribute('aria-label') || '';
          finish = finish.replace(/\s*(?:·|—|-)\s*Sold out\s*$/i,'').trim();
          if(!finish){ return; }
          labelEl.textContent = ' — ' + finish;
          var titleLink = labelEl.closest('.product-card__title');
          if(titleLink){
            var base = titleLink.getAttribute('data-wv-card-title-base') || '';
            if(base){ titleLink.setAttribute('aria-label', base + ' — ' + finish); }
          }
        }
        function syncAvailability(card, swatch){
          if(!card || !swatch){ return; }
          var sold = swatch.getAttribute('data-available') !== 'true';
          card.classList.toggle('wv-card-soldout', sold);
          var pill = card.querySelector('.wv-card-soldout-pill');
          if(pill){ pill.hidden = !sold; }
          var submits = card.querySelectorAll('[data-wv-card-variant-submit]');
          for(var i=0;i<submits.length;i++){
            var button=submits[i];
            var label=button.querySelector('[data-sold-out]');
            if(label && !label.dataset.wvAvailableText){
              label.dataset.wvAvailableText=label.textContent.trim();
            }
            button.disabled=sold;
            button.toggleAttribute('aria-disabled',sold);
            if(label){
              label.textContent=sold ? (label.getAttribute('data-sold-out')||'Sold out') : label.dataset.wvAvailableText;
            }
            if(!sold && button.form){
              button.form.error=false;
              if(typeof button.form.handleErrorMessage==='function'){ button.form.handleErrorMessage(); }
            }
          }
        }
        if(!touch){
          document.addEventListener('mouseover', function(e){
            var s = e.target.closest && e.target.closest('.wv-card-fin');
            if(!s){ return; }
            var c = s.closest('.product-card');
            if(c){
              fade(imgEl(c), s.getAttribute('data-img'), s.getAttribute('data-img-alt'));
              syncAvailability(c, s);
            }
          });
          document.addEventListener('mouseout', function(e){
            var f = e.target.closest && e.target.closest('.wv-card-fins');
            if(!f || f.contains(e.relatedTarget)){ return; }
            var c = f.closest('.product-card');
            if(c && !c.__wvLock){
              restore(c);
              var active = c.querySelector('.wv-card-fin.is-active');
              if(active){ syncAvailability(c, active); }
            }
          });
        } else {
          document.addEventListener('click', function(e){
            var s = e.target.closest && e.target.closest('.wv-card-fin');
            if(!s){ return; }
            /* A selected finish is already the destination: tapping it again follows its
               product + variant URL. A first tap on another finish only previews/selects it. */
            if(s.classList.contains('is-active')){ return; }
            e.preventDefault(); e.stopPropagation();
            var c = s.closest('.product-card'); if(!c){ return; } c.__wvLock = true;
            var act = c.querySelectorAll('.wv-card-fin.is-active');
            for(var i=0;i<act.length;i++){ act[i].classList.remove('is-active'); }
            s.classList.add('is-active');
            fade(imgEl(c), s.getAttribute('data-img'), s.getAttribute('data-img-alt'));
            retarget(c, s);
            syncFinishLabel(c, s);
            syncAvailability(c, s);
          }, true);
        }
      })();
